import { Faq as FaqType } from 'libs/http/api/content/content.types';

import { Faq as BaseFaq } from 'ui/atoms/Faq/Faq';

interface Props {
  title?: string;
  description?: string;
  className?: string;
  data: FaqType[];
}

export const Faq = ({ title = 'Frequently asked questions', description, className, data }: Props) => {
  return <BaseFaq title={title} description={description} data={data} className={className} />;
};
